import { observable, action, computed, reaction } from 'mobx';
import { api } from '../../../services';
import { usersStore, vehicleInformationStore, registrationStore } from '../../index';

class Step_1 {
  @observable inProgress = false;

  constructor(usersStore, registrationStore, vehicleInformationStore) {
    this.usersStore = usersStore;
    this.registrationStore = registrationStore;
    this.vehicleInformationStore = vehicleInformationStore;

    reaction(
      () => this.formValues.car.make.codiceMarca,
      codiceMarca => {
        codiceMarca && this.vehicleInformationStore.loadModels(codiceMarca, registrationStore.vehicleType);
      }
    );
    reaction(() => this.formValues.car.model.codiceModello, codiceModello => codiceModello && this.vehicleInformationStore.loadTypes(codiceModello, registrationStore.vehicleType));
  }

  @action
  setInProgress(inProgress) {
    this.inProgress = inProgress;
  }

  @computed
  get isValid() {
    return true;
  }

  @computed
  get status() {
    return this.registrationStore.status;
  }

  @computed
  get session() {
    return this.registrationStore.session;
  }

  @computed
  get isCarDetailEnabled() {
    //car datas don't have to be edited (return true), unless I don't have them.
    return !this.registrationStore.car || (!this.registrationStore.car.make && !this.inProgress);
  }

  @computed
  get isCarDetailEnabledLight() {
    //car datas don't have to be edited (return true), unless I don't have them or the current status is the first.
    const { car, status } = this.registrationStore;
    return (!car || !car.make || status === 1) && !this.inProgress;
  }

  submit() {
    this.setInProgress(true);
    let updateUser = () => api({ action: 'update user' }, this.registrationStore.session, this.formValues.user);
    let updateAsset = () => {
      const { risk, type } = this.vehicleInformationStore.getRisk(this.formValues.car.make.codiceMarca);
      return api({ action: 'update asset' }, this.registrationStore.session, this.registrationStore.assetId, {
        car: this.formValues.car,
        subscription: {
          status: this.registrationStore.subscription.status > 2 ? this.registrationStore.subscription.status : 3,
          risk,
          type
        }
      });
    };

    return Promise.all([updateUser(), updateAsset()])
      .then(([updatedUser, updatedAsset]) => {
        updatedUser.assets[0] = updatedAsset;
        this.usersStore.addOrModify(updatedUser);
        this.registrationStore.setSession(updatedUser._id);
        return {};
      })
      .catch(error => {
        console.error(error);
        return { error };
      })
      .then(({ error }) => {
        this.setInProgress(false);
        if (error) {
          throw error;
        }
      });
  }

  @action
  setFormField(field, value) {
    this.registrationStore.setFormField('step_1', field, value);
  }

  @computed
  get formValues() {
    return this.registrationStore.formValues.step_1;
  }
}

export default new Step_1(usersStore, registrationStore, vehicleInformationStore);



// WEBPACK FOOTER //
// ./src/stores/registrationStore/steps/step_1.js